import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createRole } from '@services/rbac.service';
import { ROLES_QUERY_KEY } from './useRoles';

export const useCreateRole = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (body) => createRole(body),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ROLES_QUERY_KEY });
        },
    });
};
